/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import GroupTitle from '../../../../features/GroupTitle';
import { BodyMain } from '../../../../components/Text';
import List, { ListItem } from '../../../../components/List';

interface Props {
  profile: any;
  profileId: number;
  isMainProfile: boolean;
  hasRoundedWrapper: boolean;
  groupIds: any[];
  onSelectGroup(id): void;
  disabledGroupIds: any[];
  listItemClass: string;
}
const GroupsList: React.FC<Props> = (props) => {
  const { groupIds, onSelectGroup, hasRoundedWrapper = true, listItemClass } = props;
  const disabledGroupIds = props.disabledGroupIds || [];

  return (
    <List hasBorder hasRoundedWrapper={hasRoundedWrapper} paddingSize="default">
      {
        groupIds.map((groupId, index) => (
          <ListItem
            key={index}
            className={listItemClass}
            onClick={() => {
              onSelectGroup(groupId);
            }}
            style={{ paddingTop: 18, paddingBottom: 18 }}
            disabled={disabledGroupIds.find(id => id === groupId) >= 0}
          >
            <BodyMain><GroupTitle groupId={groupId} withOrganizationName /></BodyMain>
          </ListItem>
        ))
      }
    </List>
  );
};

export default GroupsList;
